module.exports = __webpack_public_path__ + "img/dw_01.e8859a12.png";